export const STATE_BRAND_CHECK = 2;
export const STATE_BRAND_CORRECTION = 6;
export const STATE_TAXONOMY_CHECK = 12;
export const STATE_TAXONOMY_CORRECTION = 16;

export const QUERY_ORDER_BY_RSD_ID = 0;
export const QUERY_ORDER_BY_CATEGORY_ID = 1;
export const QUERY_ORDER_BY_COUNT_ID = 2;
export const QUERY_ORDER_BY_BRAND_ID = 3;